function getTLDFromHostname () {
    const hostname = window.location.hostname;
    if (hostname === "localhost") return "US";

    const parts = hostname.split('.');
    return parts.length > 1 ? parts[parts.length - 1] : null;
}

export default getTLDFromHostname;